module.exports = __webpack_public_path__ + "media/images/benefit-06-33fd10e4081fefc8c4bc18881356ee1c.svg";